export function getWildcardDomain(url: string): string {
  if (url === undefined || url.includes('localhost')) return 'localhost';
  const hostname = new URL(url).hostname;
  const split = hostname.split('.');
  split.splice(0, 1, '');
  return split.join('.');
}
